import { useState } from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { NavBar } from "../../components/NavBar";
import BackgroundImage from "../../images-optimized/bgcontactus.webp";
import { FooterIconSection } from "../../components/FooterIcons";



const ContactUsContainer = styled.div`
    ${tw`
        w-full
        flex
        flex-col
        // h-screen
        relative
        h-full
        align-items[center]
    `}
`;

const LandingSection = styled.div`
  ${tw`
        w-full
        overflow-scroll
        flex
        flex-col
        min-h-screen
    `};
  background-image: url(${BackgroundImage});
  background-size: cover;
  background-blend-mode: overlay;
`;

const FormContainer = styled.div`
${tw` 
    width[100%]
    height[70%] 
    my-6 
    mr-auto
    xl:ml-20
    md:ml-14
    max-w-3xl
`}`

export function ContactUs() {
    
    return (
        <ContactUsContainer>
            <LandingSection>
                <NavBar />
                <FormContainer>
                    <div className="mb-2 mt-2 border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                        <div className="flex text-center justify-between p-5 border-b border-solid border-gray-300 rounded-t flex-col">
                            <h3 className="text-3xl font=semibold mb-3">Get in Touch</h3>
                            <p className="text-lg">If you are interested in collaborating with Kumo x World, </p>
                            <p className="text-lg">email us at kumoxworld@gmail.com with subject title "COLLABORATION ENQUIRY".</p>
                            <br></br>
                            <p className="text-lg">Look forward to hearing from you.</p>
                            

                        </div>
                        <div className="relative p-6 flex-auto">
                        </div>
                    </div>
                </FormContainer>
            </LandingSection>
            <FooterIconSection></FooterIconSection>
        </ContactUsContainer>)
};
